import { UsersActionTypes } from "./users-types";

const INITIAL_STATE = {
  selectedTabAdmin: "Users",
  allUsers: null,
  isFetchingUsers: false,
  isFetchingAllUsers: false,
  errorMessage: "",
  users: null,
  searchQueryUsers: {
    PageSize: 10,
    PageNumber: 1,
    SortDesc: false,
    SortBy: "name",
    Filters: [],
  },
  numUsers: 0,
  selectedUsers: [],
  isFetchingUsersOnPage: false,
};

const usersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UsersActionTypes.FETCH_USERS_START:
      return {
        ...state,
        isFetchingUsers: true,
      };
    case UsersActionTypes.FETCH_USERS_SUCCESS:
      return {
        ...state,
        isFetchingUsers: false,
        users: action.payload[0],
        numUsers: action.payload[1],
      };
    case UsersActionTypes.FETCH_USERS_FAILURE:
      return {
        ...state,
        isFetchingUsers: false,
        errorMessage: action.payload,
      };
    case UsersActionTypes.FETCH_ALL_USERS_START:
      return {
        ...state,
        isFetchingAllUsers: true,
      };
    case UsersActionTypes.FETCH_ALL_USERS_SUCCESS:
      return {
        ...state,
        isFetchingAllUsers: false,
        allUsers: action.payload,
      };
    case UsersActionTypes.FETCH_ALL_USERS_FAILURE:
      return {
        ...state,
        isFetchingAllUsers: false,
        errorMessage: action.payload,
      };
    case UsersActionTypes.SET_USERS_ON_PAGE:
      return {
        ...state,
        usersOnPage: action.payload,
        isFetchingUsersOnPage: false,
      };
    case UsersActionTypes.SET_SEARCH_QUERY_USERS:
      return {
        ...state,
        searchQueryUsers: action.payload,
      };
    case UsersActionTypes.ADD_SELECTED_USER:
      return {
        ...state,
        selectedUsers: [...state.selectedUsers, action.payload],
      };
    case UsersActionTypes.DELETE_SELECTED_USER:
      return {
        ...state,
        selectedUsers: [
          ...state.selectedUsers.slice(
            0,
            state.selectedUsers.indexOf(action.payload)
          ),
          ...state.selectedUsers.slice(
            state.selectedUsers.indexOf(action.payload) + 1
          ),
        ],
      };
    case UsersActionTypes.SET_SELECTED_USER:
      return {
        ...state,
        selectedUsers: action.payload,
      };
    case UsersActionTypes.SET_ADMIN_TAB:
      return {
        ...state,
        selectedTabAdmin: action.payload,
      };
    default:
      return state;
  }
};

export default usersReducer;
